import Raven from 'raven-js';
import { ToolAccessErrorResponse } from '../types/ToolAccessErrorResponse';

const sentryPrefix = 'ui-tool-access';

class ToolAccessRequestException extends Error {
  constructor(name = '', message = '', ...args: []) {
    super(message, ...args);
    this.message = message;
    this.name = `ToolAccessRequestException - ${name}`;
  }
}

export function reportRequestException(
  requestName: string,
  errorResponse: ToolAccessErrorResponse,
  extra = {}
) {
  try {
    const chirpError = errorResponse.cause?.cause;
    const errorReason = chirpError?.reason ?? 'UNKNOWN_REASON';
    const status = errorResponse.cause?.status ?? 'unknown';
    const errorMessage = `[${sentryPrefix}][${status}][${requestName}]`;
    const toolAccessRequestException = new ToolAccessRequestException(
      String(errorReason),
      errorMessage
    );
    Raven.captureException(toolAccessRequestException, {
      level: 'error',
      extra: {
        ...chirpError,
        ...extra,
      },
    });
  } catch (e) {
    Raven.captureException(new Error('Unhandled request exception'), {
      level: 'error',
      extra: {
        ...errorResponse,
        ...extra,
      },
    });
  }
}
